import React from 'react';
import { Route, Switch, BrowserRouter, Redirect } from 'react-router-dom';
import { Provider } from 'react-redux';
import Header from './components/Header/index';
import Loader from './components/Loader/index';
import store from './store';
import CreateSchedule from './pages/CreateSchedule/index';
import CreateCalendar from '../src/pages/CreateCalendar/index';
import PickupSlot from '../src/pages/PickupSlot/index';
import FinalPage from '../src/pages/FinalPage/index';
import Error from '../src/pages/Error/index';
import RedirectHandler from '../src/components/RedirectHandler/index';
import CancelAttendee from '../src/pages/CancelAttendee/index';
// These must be the first lines in src/index.js
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

const CREATE_CALENDAR = '/Create-Event';
const CREATE_SCHEDULE = '/host/:guid';
const ATTENDEE_SLOT = '/attendee/:guid';
const CONFIRM_ATTENDEE_SLOT = '/attendee/:guid/:attendeeId';
const CANCEL_ATTENDEE_SLOT = '/cancel/attendee/:guid/:attendeeId';
const FINAL = '/final';
const ERROR = '/error';

const Root = () => {
    return (
        <BrowserRouter>
            <Provider store={store}>
                <Header />
                <Loader />
                <RedirectHandler />
                <Switch>
                    <Route exact path={'/'}>
                        <Redirect to={CREATE_CALENDAR} />
                    </Route>
                    <Route exact path={CREATE_CALENDAR} component={CreateCalendar} />
                    <Route exact path={CREATE_SCHEDULE} component={CreateSchedule} />
                    <Route exact path={ATTENDEE_SLOT} component={PickupSlot} />
                    <Route exact path={CONFIRM_ATTENDEE_SLOT} component={PickupSlot} />
                    <Route exact path={CANCEL_ATTENDEE_SLOT} component={CancelAttendee} />
                    <Route exact path={FINAL} component={FinalPage} />
                    <Route exact path={ERROR} component={Error} />
                </Switch>
            </Provider>
        </BrowserRouter>
    );
};

export default Root;